/**
 * App Specific Route Mapping
 *Like
 */
const nameMapping = {
  Settings: "Questions",
  Content: "Announcements"
};

/**
 * App Specific Configurations
 */
const config = {
  hasActiveEntry: true,
  // extraColumnKeys: ["savedLocation"],
  evaluation: true,
  wideLayout: true
};

const MAX_SCORE = 5;

/**
 * Filters irrelevant entries (e.g. entries that don't have meaningful data) and evaluates them
 * @param {Array} entries - The entries to filter and evaluate
 * @returns {Array} - The filtered and evaluated entries
 */
function tableEntries(entries) {
  entries = entries.filter((entry) => {
    // ---- modify the following line to add custom filtering logic --------------------------------
    return entry.value.savedLocation;
  });

  // ---- add additional evaluation here, if needed ----------------------------------------
  entries = evaluate(entries);

  return entries;
}

/**
 * Evaluates the entries for completeness
 * @param {Array} entries - The entries to evaluate
 * @returns {Array} - The entries with the completed property added, if applicable
 */
function evaluate2(entries) {
  entries = entries.map((entry) => {
    // ---- modify the following line to add custom completion evaluation logic --------------
    entry.completed = entry.value.savedLocation === MAX_SCORE;
    return entry;
  });

  return entries;
}

/**
 * Scores the entries
 * @param {Array} entries - The entries to score
 * @returns {Array} - The entries with the score, maxScore, and percent properties added
 */
function evaluate(entries) {
  entries = entries.map((entry) => {
    // ---- modify the following lines to add custom scoring logic ---------------------------
    entry.score = entry.value.savedLocation;
    entry.maxScore = MAX_SCORE;
    entry.percent = Math.round((entry.score / entry.maxScore) * 100);
    return entry;
  });

  return entries;
}

/**
 * Transforms an array of entry objects by mapping each entry to a new object
 * with specific properties: fullname, onid, value, and "Last Updated".
 *
 * @param {Array} entries - The array of entry objects to be transformed.
 * @param {string} entries[].fullname - The full name of the entry.
 * @param {string} entries[].onid - The ONID of the entry.
 * @param {any} entries[].value - The value associated with the entry.
 * @param {string} entries[].tsUpdatedLabel - The timestamp label of the last update.
 * @returns {Array} - A new array of objects with the properties: fullname, onid, value, and "Last Updated".
 */
function exportEntries(entries) {
  const mappedEntries = entries.map((entry) => {
    // ---- modify this object to create a custom export format suited for the admin user's needs ----
    return {
      fullname: entry.fullname,
      onid: entry.onid,
      savedLocation: entry.value,
      "Last Updated": entry.tsUpdatedLabel
    };
  });

  return mappedEntries;
}

export {
  nameMapping,
  config,
  exportEntries,
  tableEntries,
  evaluate,
  evaluate2
};
